import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchGenderData = createAsyncThunk(
  "api/fetchGenders",
  async () => {
    const token = localStorage.getItem("other");
    const response = await fetch(EndPoints.PRISM_GET_GENDER_LIST, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  }
);

const genderSlice = createSlice({
  name: "gender",
  initialState: {
    genderdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGenderData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGenderData.fulfilled, (state, action) => {
        state.loading = false;
        state.genderdata = action.payload?.data || [];
      })
      .addCase(fetchGenderData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default genderSlice.reducer;